import {Injectable} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import jwtDecode from 'jwt-decode';

declare const fbq: any;
declare const sendinblue: any;
declare const WonderPush: any;

// declare const gtag: any;
// declare const mixpanel: any;
declare global {
    interface Window {
        dataLayer: any;
        hj: any;
        WonderPush: any;
    }
}

@Injectable({
    providedIn: 'root'
})

export class TrackingService {

    constructor(
        public authenticationService: AuthenticationService,
        private http: HttpClient) {
    }

    initPixel() {
        if (this.authenticationService.isLogin) {
            const user = this.authenticationService.currentUser;
            if (typeof fbq !== 'undefined') {
                fbq('init', '738775470234919', {
                    em: user.email,
                    fn: user.firstname,
                    ln: user.lastname,
                    external_id: user.email
                });
            }

            var userId = user.id || null; // Replace your_user_id with your own if available.
            var plan = user.plan;
            if (user.pro_plan != '') {
                plan = user.pro_plan;
            }
            if (window.hj !== undefined) {
                window.hj('identify', userId, {
                    'email': user.email,
                    'created_at': user.created_at,
                    'plan': plan,
                    'identifiant': user.email.replace('@', '[arobase]'),
                    'rate': (user.rate_answer ? user.rate_answer.general : 0),
                    'type': (user.answer ? user.answer.profil : ''),
                });
            }
            if ( typeof sendinblue !== 'undefined') {
                sendinblue.identify(user.email);
            }

            if (window.WonderPush !== undefined) {
                window.WonderPush.push(['setUserId', user.id]);
            }
        }
    }

    login(params) {
        this.sendEvent('login', '', params);
        this.initPixel();
    }

    need2auth(params) {
        this.sendEvent('need2auth', '', params);
        this.initPixel();
    }

    search(params) {
        this.initPixel();
    }

    searchCity() {
        this.initPixel();
    }

    subscribe(params) {
        this.sendEvent('subscribe', "", String(params));
        this.initPixel();
        if (window.dataLayer !== undefined) {
            window.dataLayer.push({'event': 'subscription_front'});
        }

        if (typeof sendinblue !== 'undefined') {
            setTimeout(function() {
                sendinblue.track(
                    'Subscribe', params, params
                );
            }.bind(params), 500);
        }
    }

    checkout(params) {
        this.sendEvent('checkout', "", String(params));
        this.initPixel();
    }

    register() {
        this.sendEvent('register', "", "");
        this.initPixel();
        if (window.dataLayer !== undefined) {
            window.dataLayer.push({'event': 'completeRegistrationWelcome'});
        }
        // if (typeof sendinblue !== 'undefined') {
        //     sendinblue.track(
        //         'CompleteRegistration'
        //     );
        // }
    }

    // Cancel subscription
    cancel() {
        this.sendEvent('subscription_cancel', "", "");
        this.initPixel();
        if (typeof sendinblue !== 'undefined') {
            sendinblue.track(
                'Unsubscribe'
            );
        }
    }

    // fail subscription
    subscribeFail() {
        this.sendEvent('subscription_fail', "", "");
        this.initPixel();
        if (typeof sendinblue !== 'undefined') {
            sendinblue.track(
                'CheckoutFail'
            );
        }
    }

    addFavorite() {
        this.sendEvent('favorite_add', "", "");
        this.initPixel();
    }

    addFavoriteList() {
        this.sendEvent('favorite_list_add', "", "");
        this.initPixel();
    }

    deleteFavoriteList() {
        this.sendEvent('favorite_list_delete', "", "");
        this.initPixel();
    }

    deleteFavorite() {
        this.sendEvent('favorite_delete', "", "");
        this.initPixel();
    }

    click(item, data) {
        this.sendEvent('click', item, data);
    }

    url(url) {
        this.sendEvent('navigate', '', url);
    }

    sendEvent(action, message, data) {
        let userId = 0;
        let uniqueId = '';

        let jwt = localStorage.getItem('token');
        if (jwt) {
            userId = jwtDecode(jwt)['id'];
        }

        if (!jwt || action == 'login') {
            let uId = localStorage.getItem('uId');
            if (!uId) {
                uniqueId = (Math.random() + 1).toString(36).substring(7) + '-' + (Math.random() + 1).toString(36).substring(7) + '-' + (Math.random() + 1).toString(36).substring(7);
                localStorage.setItem('uId', uniqueId);
            } else {
                uniqueId = uId;
            }
            if (action == 'login') {
                localStorage.setItem('uId', '');
            }
        }

        this.http.post(`${environment.apiUrl}app/log`, {
            action: action,
            message: String(message),
            userId: userId,
            uniqueId: uniqueId,
            data: String(data),
        }).subscribe(
            data => {
            },
            error => {
                console.log(error);
            });
    }
}
